import { lazy, Suspense } from "react";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import { organizationSchema, websiteSchema } from "@/lib/homeJsonLd";

const HomeSections = lazy(() => import("@/components/HomeSections"));

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <main id="main-content">
        <Hero />
        <Suspense fallback={<div className="min-h-[40vh]" aria-hidden />}>
          <HomeSections />
        </Suspense>
      </main>
      <Footer />
    </>
  );
}
